import React, { useState, useEffect, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup, Row, Col } from 'reactstrap';
import moment from 'moment';

const EditTimeslotModal = ({ isOpen, toggle, onSave, timeslot, schedule, serviceDuration }) => {
  const [editedTimeslot, setEditedTimeslot] = useState({
    start: '',
    end: '',
    priority: ''
  });

  useEffect(() => {
    if (timeslot) {
      // Convert HH:mm:ss to HH:mm for input
      setEditedTimeslot({
        start: timeslot.start ? moment(timeslot.start, 'HH:mm:ss').format('HH:mm') : '',
        end: timeslot.end ? moment(timeslot.end, 'HH:mm:ss').format('HH:mm') : '',
        priority: timeslot.priority ?? ''
      });
    }
  }, [timeslot]);

  const computedEnd = useMemo(() => {
    if (!editedTimeslot.start || !serviceDuration) {
      return '';
    }
    return moment(editedTimeslot.start, 'HH:mm')
      .add(serviceDuration, 'minutes')
      .format('HH:mm');
  }, [editedTimeslot.start, serviceDuration]);

  const handleSave = () => {
    // Convert HH:mm to HH:mm:ss for backend
    const timeslotData = {
      schedule: schedule?.id,
      league: schedule?.league,
      start: editedTimeslot.start ? `${editedTimeslot.start}:00` : '',
      end: computedEnd ? `${computedEnd}:00` : '',
      priority: editedTimeslot.priority === '' ? null : Number(editedTimeslot.priority)
    };
    onSave(timeslotData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedTimeslot(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Timeslot</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="start">Start Time *</Label>
              <Input
                type="time"
                id="start"
                name="start"
                value={editedTimeslot.start}
                onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="end">End Time</Label>
              <Input
                type="time"
                id="end"
                name="end"
                value={computedEnd}
                readOnly
                disabled
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="priority">Priority</Label>
              <Input
                type="number"
                id="priority"
                name="priority"
                value={editedTimeslot.priority}
                onChange={handleChange}
                min="0"
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!editedTimeslot.start || !serviceDuration}>
          Save Changes
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditTimeslotModal;
